import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token, responsive }) => {
  return {
    card: {
      width: 465,

      [responsive.xl]: {
        width: 350
      },

      [responsive.md]: {
        width: 330
      }
    },

    organization: {
      '&.ant-typography': {
        fontWeight: 500
      }
    },

    role: {
      color: token.colorTextTertiary,
      fontSize: token.fontSize
    },

    button: {
      marginLeft: 'auto'
    }
  }
})
